import { defineMessages } from 'react-intl';

export default defineMessages({
  NavPanelSignOut: {
    id: 'NavPanelSignOut',
    defaultMessage: 'Sign out',
  },
});
